import { Injectable, inject } from '@angular/core';

import { Synonym } from '@shared/models/synonym';
import { ClubHubDataService } from '@shared/services/clubhub-data.service';

@Injectable({
  providedIn: 'root',
})
export class DictionaryService {
  private readonly clubHubDataService = inject(ClubHubDataService);

  public getSynonyms() {
    return this.clubHubDataService.get<Synonym[]>('CriteriaSynonyms');
  }

  public saveSynonym(synonym: Synonym) {
    return this.clubHubDataService.put<Synonym>('CriteriaSynonyms', synonym);
  }

  public editSynonym(synonym: Synonym) {
    return this.clubHubDataService.patch<Synonym>('CriteriaSynonyms', synonym);
  }

  public deleteSynonym(id: number) {
    return this.clubHubDataService.delete<number>(`CriteriaSynonyms/${id}`);
  }
}
